import { Component } from '@angular/core';
import { SessionService } from 'src/app/features/shared/services/Session.service';

@Component({
  selector: 'system-alarmsPage',
  templateUrl: './system-alarmsPage.component.html',
  styleUrls: ['./system-alarmsPage.component.css']
})
export class SystemAlarmsPageComponent {

  constructor(private sessionService: SessionService) { }
  
    ngOnInit(): void {
      this.sessionService.setIsExternalMap(false);
    }
  
}
